import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Landing from "../pages/Landing/index";
import LoginForm from "../pages/auth/ConnexionForm";
import Contact from "../pages/contact/index";
import LegalNotices from "../pages/LegalNotices/index";
import PrivacyPolicy from "../pages/PrivacyPolicy/index";
import AdminDashboard from "../pages/Dashboard/AdminDashboard";
import AssistanteDashboard from "../pages/Dashboard/AssistanteDashboard";
import CommercialDashboard from "../pages/Dashboard/CommercialDashboard";
import CreatePassword from "../pages/auth/CreatePassword";
import VehiculeForm from "../pages/Forms/VehiculeForm";
import VehiculeViewPage from "../pages/Forms/VehiculeViewPage";
import PdfGeneration from "../pages/PdfGeneration";
import PrivateRoute from "./PrivateRoute";
import PropTypes from "prop-types";
import DocumentUploader from "../pages/Dashboard/AdminDashboard/document";

const AppRoutes = ({ menuState }) => {
  return (
    <Routes>
      <Route path="/" element={<Landing menuState={menuState} />} />
      <Route path="/login" element={<LoginForm menuState={menuState} />} />
      <Route path="/contact" element={<Contact menuState={menuState} />} />
      <Route path="/mentions-legales" element={<LegalNotices menuState={menuState} />} />
      <Route path="/politique-confidentialite" element={<PrivacyPolicy menuState={menuState} />} />
      <Route
        path="/admin-dashboard"
        element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/assistante-dashboard"
        element={
          <PrivateRoute>
            <AssistanteDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/commercial-dashboard"
        element={
          <PrivateRoute>
            <CommercialDashboard />
          </PrivateRoute>
        }
      />
      <Route path="/create-password/:id" element={<CreatePassword />} />
      <Route
        path="/create-vehicule/:vehiculeId?"
        element={
          <PrivateRoute>
            <VehiculeForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/vehicule/:id"
        element={
          <PrivateRoute>
            <VehiculeViewPage menuState={menuState} />
          </PrivateRoute>
        }
      />
      <Route
        path="/generation-pdf"
        element={
          <PrivateRoute>
            <PdfGeneration />
          </PrivateRoute>
        }
      />

      {/* ROUTE AJOUT DE DOCUMENTS NE PAS SUPPRIMER */}
      <Route
        path="/document"
        element={
          <PrivateRoute>
            <DocumentUploader />
          </PrivateRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

AppRoutes.propTypes = {
  menuState: PropTypes.shape({
    isMenuOpen: PropTypes.bool,
    onMenuToggle: PropTypes.func,
  }),
};

export default AppRoutes;